module.exports = __webpack_public_path__ + "assets/img/66f4-ps.svg";